<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="AdminSectionId.FILE_MANAGEMENT"></app-admin-navigation>
    </div>

    <!-- Header -->
    <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
        <img src="assets/icons/optimization/file-neutral.svg" class="w-[24px] h-[24px]"
            alt="{{ 'shared.icon' | transloco }}">
        <h1 class="font-bold text-xl">
            {{ 'admin.file_management' | transloco }}</h1>
    </div>

    <!-- Electricity & Gas-->
    <div class="w-full py-2">
        <app-drop-down-section title="{{ 'dashboard.electricity_and_gas' | transloco }}" [defaultOpen]="true">
            <!-- Actions-->
            <div class="flex flex-col gap-2 w-full">
                <!-- Gas Taxes -->
                <p class="text-lg font-bold pl-5 mt-5">{{ 'admin.electricity_pun_gas_market_prices' | transloco }}</p>
                <div class="w-full max-w-ultrawide">
                    <app-admin-electricity-and-gas-prices [toast]="toast"></app-admin-electricity-and-gas-prices>
                </div>
            </div>
        </app-drop-down-section>
    </div>

    <!-- Gas-->
    <div class="w-full py-2">
        <app-drop-down-section title="{{ 'shared.gas' | transloco }}" [defaultOpen]="true">
            <!-- Actions-->
            <div class="flex flex-col gap-2 w-full">
                <!-- Gas Taxes -->
                <p class="text-lg font-bold pl-5 mt-5">{{ 'admin.gas_taxes' | transloco }}</p>
                <div class="w-full max-w-ultrawide">
                    <app-admin-gas-taxes-files [toast]="toast"></app-admin-gas-taxes-files>
                </div>

                <!-- Separator -->
                <div class="h-[1px] w-full bg-border"></div>

                <!-- Distribution Tariff -->
                <p class="text-lg font-bold pl-5 mt-5">{{ 'admin.gas_distribution_tariff' | transloco }}</p>
                <div class="w-full max-w-ultrawide">
                    <app-admin-gas-distribution-tariff-files [toast]="toast"></app-admin-gas-distribution-tariff-files>
                </div>

                <!-- Separator -->
                <div class="h-[1px] w-full bg-border"></div>

                <!-- Accise Gas -->
                <p class="text-lg font-bold pl-5 mt-5">{{ 'admin.accise_gas' | transloco }}</p>
                <div class="w-full max-w-ultrawide">
                    <app-admin-accise-gas-files [toast]="toast"></app-admin-accise-gas-files>
                </div>
            </div>
        </app-drop-down-section>
    </div>
</div>